import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import LazyLoad from 'vanilla-lazyload';

import 'jquery-hoverintent';
import 'scrolltofixed';
import 'slick-carousel';

import { swiffyslider } from 'swiffy-slider';
import "swiffy-slider/css";

import OneDrawer from '@/modules/module-oneDrawer';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneSubscribe from '@/modules/module-oneSubscribe';
import OneCookieBanner from '@/modules/module-oneCookieBanner';
import OneMobileMenu from '@/modules/module-oneMobileMenu';
import OneMarketing from '@/modules/module-oneMarketing';
import OneVerification from '@/modules/module-oneVerification';
import OnePredictiveSearch from '@/modules/module-onePredictiveSearch';
import OneCart from '@/modules/module-oneCart';
import OneGWP from '@/modules/module-oneGWP';
import OneSP from '@/modules/module-oneSP';
import OneQuickShop from '@/modules/module-oneQuickShop';
import OneEduKit from '@/modules/module-oneEduKit';
import OneVideo from '@/modules/module-oneVideo';
import { PUB_SUB_EVENTS, subscribe, publish } from '@/lib/pubsub';

export default Backbone.View.extend({
    
    initialize: function (opts) {
        
        console.log('init global');
        
        // Testing $ object
        // console.log($.fn.jquery);
        
        var self = this;
        self.$body = self.$el;
        self.$header = $('header.site-header');
        self.$footer = $('footer.site-footer');
        self.$miniCart = $('#MiniCart');
        self.$mobileNav = $('#MobileNav');
        self.$searchBar = $('#SearchBar');
        self.$promoBanner = self.$header.find('.promo-banner');
        self.$navi = self.$header.find('nav.nav-bar');
        self.$menuToggle = self.$header.find('.menu-toggle');

        // Modules
        self.modulesGlossary = document.querySelectorAll('.global-module-glossary');
        self.modulesQuickLinks = document.querySelectorAll('.global-module-quick-links');
        self.modulesSplitContent = document.querySelectorAll('.global-split-content-module');
        self.modulesShippingCountdown = document.querySelectorAll('.global-module-shipping-countdown');
        self.modulesValueProps = document.querySelectorAll('.global-module-value-props');
        self.gatedPageModals = document.querySelectorAll('.gated-page-json');
        self.readMoreBlocks = document.querySelectorAll('.read-more-block');
        
        self.searchInlineMode = false; // Set false to use search modal, set true to use inline search mode. 
        self.miniCartAsDropdown = false; // Set false to use drawer, set true to use dropdown on Desktop (drawer on Mobile).
        self.useSlideInMenuForLevel2 = true; // Set false to use accordion for all nav levels on Mobile, set true to use the slide-in-menu for level 2.

        self.initLazyImages();
        self.initPromoBanner();
        self.initCookieBanner();
        self.initFixedHeader();
        self.initNavi();
        self.initUtilities();
        self.initSearch();
        self.initPredictiveSearch();
        self.initMiniCart();
        self.initMobileMenu();
        self.initSubscirbe();
        self.initFooter();
        self.initModules();
        self.initQuickShop();
        self.initReadMore();
        self.initGatedPageModals();
        self.initEducationBanner();
        self.devTools();

        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing ||  new OneMarketing;
            ORW.marketing.initPromoWatchers();
            ORW.marketing.initWishlistWatcher();

            if (ORW.verification) {
                OneVerification.init({ marketing: ORW.marketing });
            }
        }

        if (ORW.GWP && ORW.GWP.enable == `true`) {
            OneGWP.init()
        }

        if (ORW.SP && ORW.SP.enable == `true`) {
            OneSP.init()
        }

        // Initialize Education Kit Manager
        OneEduKit.init()

        self.initCartOnPageLoad()
    },

    events: {
        'drawer-opt' : 'bodyClassCtl',
        'menu-opt-in' : 'bodyClassCtl',
        'menu-opt-out' : 'bodyClassCtl'
    },
    
    bodyClassCtl : function(e){
        // Please prevent operation on more then one drawer at the same time
        var self = this;
        var type = e.type;
        if (type == 'drawer-opt') {
            self.$body.toggleClass('drawer-opt');
            self.$body.toggleClass('show-overlay');
        } else {
            if (type == 'menu-opt-in') {
                self.$body.addClass('show-overlay');
                self.$header.addClass('menu-opt-in');
            } else if (type == 'menu-opt-out') {
                self.$body.removeClass('show-overlay');
                self.$header.removeClass('menu-opt-in');
            }
        }
    },

    initLazyImages: function() {
        window.ORW.lazyload = new LazyLoad({ threshold: 0 });

        const events = {
            'mouseenter .product-image-wrapper' (e) {
                $(e.currentTarget).find('.product-image.alt').removeClass('hide');
            },
        };

        _.extend(this.events, events);
        this.delegateEvents();
    },

    initPromoBanner: function(){
        var self = this;
        var cookieEnabled = self.$promoBanner.data('cookieenabled');
        var cookieDays = self.$promoBanner.data('days');

        if(self.$promoBanner.length > 0){
            // if(!ORW.utilities.getCookie('promo_banner') && self.$body.hasClass('template-index')){
            if(!ORW.utilities.getCookie('promo_banner')) {
                self.$body.addClass('promo-banner-active');
                self.$promoBanner.addClass('activate');
            }

            if (self.$promoBanner.data('slider') == 'true' || self.$promoBanner.data('slider') == true) {
                const slider = self.$promoBanner.find(`.swiffy-slider`)[0]
                swiffyslider.initSlider(slider)
            }
        }

        var events = {
            'click .close-promo' : function(e){
                self.$promoBanner.slideUp(200);
                self.$body.removeClass('promo-banner-active');
                self.$promoBanner.removeClass('activate');

                if(!ORW.utilities.getCookie('promo_banner') && cookieEnabled ){
                    ORW.utilities.setCookie('promo_banner','shown', cookieDays);
                }
            }
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initCookieBanner: function(){
        var self = this;
        if ($('.cookie-banner').length) {
            ORW.cookieBanner = OneCookieBanner.init({
                el: $('.cookie-banner')
            });
        }
    },
    
    initFixedHeader: function() {
        var self = this;
        // Uncomment following code if you need better control on fixed header scrolling, by default the header always fixed by CSS 
        self.$header.scrollToFixed({
            dontSetWidth : true
        });
        
        // Mobile header scroll control
        var lastScrollTop = 0;
        var mobileHeaderHeight = 44;
        var checkScrollDirection = function(){
            var st = $(window).scrollTop();
            if (st > lastScrollTop && st >= mobileHeaderHeight){
                // downscroll code
                if (st - lastScrollTop >= 10) {
                    self.$header.removeClass('scroll-up').addClass('scroll-down');
                }
            } else {
                // upscroll code
                self.$header.removeClass('scroll-down');
                self.$header.addClass('scroll-up');
                if (st < mobileHeaderHeight) {
                    self.$header.removeClass('scroll-up');
                }
            }
            lastScrollTop = st;
        }

        checkScrollDirection();
        $(window).scroll(function(event){
            checkScrollDirection();
        });
    },
    
    initNavi: function() {
        var self = this;
        
        self.$rawNav = self.$navi.clone();
        
        // Build mobile Nav
        var $slideInMenu = $('<div class="slide-in-menu"></div>');
        var $clonedNavi = self.$navi.clone();
        _.each($clonedNavi.find('.has-dropdown'), function(child){
            var $child = $(child);
            var $dropdown = $child.find('.dropdown');
            $dropdown.find('.extra-links').remove();
            $dropdown.find('.image-links').remove();

            if ($child.hasClass('color-scheme-light')) {
                $dropdown.addClass('color-scheme-light');
            } else if ($child.hasClass('color-scheme-dark')) {
                $dropdown.addClass('color-scheme-dark');
            }
            
            if (self.useSlideInMenuForLevel2) {
                const $mainMenu = $dropdown.find('.main-menu');

                if ($mainMenu.length > 0) {
                    const $mainMenuChildren = $mainMenu.contents();
                    $mainMenu.replaceWith($mainMenuChildren);

                }

                $dropdown.appendTo($slideInMenu);
                $child.find('.dropdown').remove();  
            } else {
                $dropdown.appendTo($child);
                $child.find('.dropdown-wrapper').remove();
                $child.find('.nav-link').removeAttr('data-trigger');
                $child.addClass('expandable');
            }
        });
        
        if (self.useSlideInMenuForLevel2) {
            $slideInMenu.appendTo($clonedNavi);
        }
        self.$mobileNav.find('.extra-links').before($clonedNavi);

        // Clone and move mobile image links
        const $mobileImageLinksContainer = $('<div class="image-links"></div>');
        
        self.$navi.find('.mobile-image-links .mobile-image-link').each(function(index, element){
            const $linkClone = element.cloneNode(true);

            $linkClone.classList.remove('mobile-image-link');
            $linkClone.classList.add('image-link');
            $mobileImageLinksContainer.append($linkClone);
        });

        self.$mobileNav.find('.nav-bar').append($mobileImageLinksContainer);

        // Build out extra links from promo bar links
        self.$promoBanner.find('.promo-banner-nav .nav-link').each(function(index, element){
            const $linkClone = element.cloneNode(true);

            $linkClone.classList.add('extra-link');
            $linkClone.classList.remove('nav-link');

            self.$mobileNav.find('.extra-links').prepend($linkClone);
        })
        
        // Build desktop nav (uncomment below code block to enable automatical column distribution based on column size setting)
        // _.each(self.$navi.find('.children.column-layout'), function(child){
        //     var currentCol = 0, html = '<li class="back-to">Back</li>';
        //     var $child = $(child);
        //     var $level2 = $child.find('.level-2');
        //     var $level2Images = $child.find('.lv2-image'); 
            
        //     _.each($level2, function(item,index){
        //         var $item = $(item);
        //         var isLast = index == $level2.length-1 ? true : false;
                
        //         if (currentCol == 0 && currentCol != $item.data('column')) {
        //             html += '<li class="divider"><ul>';
        //             currentCol = $item.data('column');
        //         } else if (currentCol != $item.data('column')) {
        //             html += '</ul></li><li class="divider"><ul>';
        //             currentCol = $item.data('column');
        //         }
                
        //         html += $('<div>').append($item.clone()).html();
                
        //         if (isLast) {
        //             html += '</ul></li>';
        //         }
        //     });
            
        //     _.each($level2Images, function(item){
        //         html += $(item)[0].outerHTML;
        //     });
            
        //     $child.html(html);
        // });
    },
    
    initUtilities: function() {
        var self = this;
        var events = {};
        
        // Header hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-in');
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    self.$body.trigger('menu-opt-out');
                }
            },
            sensitivity: 100
        });
        
        // Header dropdown hover control (Larger screen)
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) {
                    $(this).addClass('active');
                    if (self.miniCartTimer) {
                        // Check if minicart close timer exists, if so kill it.
                        console.log('kill timer');
                        clearTimeout(self.miniCartTimer);
                    }
                }
            },
            out: function(){
                if (!self.isMobile()) {
                    $(this).removeClass('active');
                }
            },
            sensitivity: 100,
            selector: '.has-dropdown:not(.block-search)'
        });
        
        // Copy extra links (if available) to Mobile menu utilities (Small screen)
        var $extraLinkContainer = self.$header.find('.header-extra-links');
        if ($extraLinkContainer.length) {
            $extraLinkContainer = $extraLinkContainer.clone();
            self.$mobileNav.find('.header-utilities').prepend($extraLinkContainer.html());
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    initSearchOld: function(){
        console.log('init search');
        
        var self = this;
        if (self.searchInlineMode) {
            self.$header.hoverIntent({
                over: function(){
                    var $target = $(this).find('.block-content');
                    $target.on('transitionend', function(){
                        $target.off('transitionend');
                        setTimeout(function(){ $target.find('input').focus(); },100);
                    });
                    $(this).addClass('active');
                },
                out: function(){
                    $(this).removeClass('active');
                },
                sensitivity: 100,
                selector: '.block-search'
            });
        } else {
            self.searchCtl = OneDrawer.init({
                drawerElem: '#' + self.$searchBar.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .search-toggle',
                openCallback: function(){
                    setTimeout(function(){ self.$searchBar.find('input').focus(); },100);
                },
                events: {
                    'click .search-form button' : function(e){
                        e.preventDefault();
                        var $form = $(e.currentTarget).parent('form');
                        if ($form.find('input').val()) {
                            this.closeDrawer();
                            $form.submit();
                        } else {
                            // May be show error message ...
                        }
                    }
                }
            });
        }
    },

    initSearch: function(){
        var self = this
        
        self.$header.find('.search-toggle').on('click', function(){
            self.$searchBar.toggleClass('hide')
        })

        self.$searchBar.find('.search-static-state').on('mouseleave', function(){
            self.$searchBar.find('.search-static-state').addClass('hide');
            self.$searchBar.find('.search-active-state').addClass('hide');
            self.$searchBar.find('input').blur();
        })

        self.$searchBar.find('.search-active-state').on('mouseleave', function(){
            self.$searchBar.find('.search-static-state').addClass('hide');
            self.$searchBar.find('.search-active-state').addClass('hide');
            self.$searchBar.find('input').blur();
        })

        // Submit search form on click of submitDesktopPredictiveSearch button from html template
        window.addEventListener('click', function(e){
            if (e.target.classList.contains('submitDesktopPredictiveSearch')) {
                e.preventDefault()
                $('#SearchBar #SearchForm').trigger('submit')
            }
        })

        // On hover navigation tabs, hide search bar
        self.$navi.find('.level-1.has-dropdown').on('mouseenter', function(){
            self.$searchBar.find('.search-static-state').addClass('hide');
            self.$searchBar.find('.search-active-state').addClass('hide');
        })
    },

    initPredictiveSearch: function() {
        var self = this;
        if ($('.predictive-search-form').length) {
            const searchFormId = '#SearchForm'
            
            ORW.predictiveSearchModal = OnePredictiveSearch.init({
                el: $('.predictive-search-form')
            });

            $(`${searchFormId} input`).on("focus", function(){
                $('#MobileNav').addClass('search-focus')
            });

            self.$header.on('click', function(e){
                $('#MobileNav').removeClass('search-focus')
            })

            $('.search-active-state button').on('click', function() {
                $(`#MobileNav ${searchFormId}`).trigger('submit')
            })
        }
    },
    
    initMobileMenu: function(){
        var self = this;
        
        self.mobileMenuCtl = OneDrawer.init({
            drawerElem: '#' + self.$mobileNav.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .menu-toggle',
            openCallback: function(e){
                self.$menuToggle.addClass('open');
                self.$body.trigger('menu-opt-in');
            },
            closeCallback: function(e){
                self.$menuToggle.removeClass('open');
                self.$body.trigger('menu-opt-out');
            }
        });
        
        self.mobileInnerMenuCtl = OneMobileMenu.init({
            el: self.$mobileNav,
            openCallback: function(e){
                self.$mobileNav.addClass('inner-action-engaged');
                self.$menuToggle.find('.hamburger').addClass('inner-action-engaged');
            },
            closeCallback: function(e){
                self.$mobileNav.removeClass('inner-action-engaged');
                self.$menuToggle.find('.hamburger').removeClass('inner-action-engaged');
            }
        });
    },
    
    initMiniCart: function() {
        var self = this;
        var miniCartDrawerInit = function(){
            console.log('init minicart as drawer');
            return OneDrawer.init({
                drawerElem: '#' + self.$miniCart.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .block-minicart',
                openCallback: function(){}
            });
        };
        var miniCartDropdownOpen = function(){
            self.$body.trigger('menu-opt-in');
            self.$header.find('.block-minicart').addClass('active');
        }
        var miniCartDropdownClose = function(){
            self.$header.find('.block-minicart').removeClass('active');
            self.$body.trigger('menu-opt-out');
        }
        
        self.miniCartCtl = miniCartDrawerInit();
        
        $('.add-to-cart-form').off('submit');
        
        if (self.miniCartAsDropdown) {
            // Init minicart as Dropdown on Desktop
            
            ORW.utilities.mediaCheck(function () {
                if (self.miniCartCtl) {
                    console.log('minicart drawer destory');
                    self.miniCartCtl.destroy();
                    self.miniCartCtl = false;
                }
            }, function () {
                if (!self.miniCartCtl) {
                    self.miniCartCtl = miniCartDrawerInit();
                }
            })
        }

        const miniCartElem = document.querySelector('#CartContainer form.cart');
        if (miniCartElem) {
            new OneCart({ el: miniCartElem });
        }

        self.unsubscribeMiniCart = subscribe(PUB_SUB_EVENTS.cartUpdate, async (data) => {
            // if drawerClose param is sent it re init the drawer without drawer open
            if(data.drawerClose) return
            const cart = await fetch('/cart.js').then(res => res.json());
            document.querySelectorAll('.minicart-count').forEach(el => {
                el.innerHTML = cart.item_count;
            });

            if (window.location.pathname === '/cart') return;
            if (self.miniCartCtl.drawerOpened) return;

            // If Post ATC Modal is present and event is pdpAdd, don't open minicart automatically
            if (data.cartEvent === 'pdpAdd' && document.querySelector('#PostATCModal.opened')) return;

            clearTimeout(self.miniCartTimer);
            if (self.miniCartCtl) {
                self.miniCartCtl.openDrawer();
                self.miniCartTimer = setTimeout(function(){ self.miniCartCtl.closeDrawer(); }, 3000);
            } else {
                miniCartDropdownOpen();
                self.miniCartTimer = setTimeout(function(){ miniCartDropdownClose(); }, 3000);
            }
        })
    },
    
    initSubscirbe: function() {
        var self = this;
        if ($('.subscribe-modal').length) {
            ORW.subscribeModal = OneSubscribe.init({
                el: $('.subscribe-modal')
            });
        }
    },
     initQuickShop: function() {
        const self = this
        
        if (document.querySelector(`.quick-shop-trigger`) || document.querySelector(`.quick-shop-trigger-link`)) {
            ORW.OneQuickShopInstance = OneQuickShop.init({})
        }
    },
    initFooter: function() {
        var self = this;
        var events = {
            'click footer.site-footer .expandable': function(e){
                if (self.isMobile()) {
                    var $curr = $(e.currentTarget);
                    var $activeSiblings = $curr.siblings('.expandable.active');
                    if ($activeSiblings.length) {
                        $activeSiblings.removeClass('active');
                    }
                    $curr.toggleClass('active');
                }
            }
        };
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initModules: function() {
    	const self = this;        

        if (self.modulesGlossary.length > 0) {
            self.modulesGlossary.forEach((moduleContainer) => {
                const intersectionOffset = self.isMobile() ? 50 : 150; // Offset based on alphabet nav
                const letterGroups = moduleContainer.querySelectorAll('.letter-group');
                const letterGroupHeadings = moduleContainer.querySelectorAll('.letter-group .letter-heading');

                const highlightNavLink = (letter) => {
                    // Get all currently visible letter groups
                    const visibleGroups = Array.from(letterGroupHeadings).filter(heading => {
                        const rect = heading.getBoundingClientRect();
                        return rect.top >= intersectionOffset && rect.bottom <= window.innerHeight;
                    });
                    
                    // Get the first visible group to determine which letter to highlight
                    const firstVisibleGroup = visibleGroups[0].closest('.letter-group');
                    if (firstVisibleGroup) {
                        const letter = firstVisibleGroup.getAttribute('data-letter');
                        const navLink = moduleContainer.querySelector(`.alphabet-nav .alphabet-link[href="#glossary-${letter}"]`);
                    
                        navLink.classList.add('active');

                        const linksToDeactivate = moduleContainer.querySelectorAll(`.alphabet-nav .alphabet-link:not([href="#glossary-${letter}"])`);
                        linksToDeactivate.forEach((otherLink) => {
                            otherLink.classList.remove('active');
                        });
                    }
                };

                // For each letter group create an intersection observer to monitor when it enters the viewport
                letterGroups.forEach((group) => {
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            const letter = group.getAttribute('data-letter');
                            const navLink = moduleContainer.querySelector(`.alphabet-nav .alphabet-link[href="#glossary-${letter}"]`);

                            setTimeout(() => {
                                highlightNavLink(letter);
                            }, 250);
                        });
                    }, {
                        root: null,
                        rootMargin: '0px 0px 0px 0px',
                        threshold: 0.9
                    });

                    observer.observe(group);
                });
            })
        }
    
    	if (self.modulesQuickLinks.length > 0) {
    		self.modulesQuickLinks.forEach((moduleContainer) => {
                const listContainer = moduleContainer.querySelector('.quick-links-list');
                const scrollbar = moduleContainer.querySelector('.scrollbar');
                const scrollbarThumb = moduleContainer.querySelector('.scrollbar-thumb');

                const checkOverflowState = () => {
                    if (listContainer) {
                        if (listContainer.scrollWidth > listContainer.clientWidth) {
                            moduleContainer.classList.add('overflowing');
                        } else {
                            moduleContainer.classList.remove('overflowing');
                        }
                    }
                }

                const initScrollbar = () => {
                    if (scrollbar && scrollbarThumb) {                        
                        const updateScrollbar = () => {
                            const scrollbarThumnbWidth = (listContainer.clientWidth / listContainer.scrollWidth) * 100;
                            const remainingScrollWidthPercentage = 100 - scrollbarThumnbWidth;
                            const scrollPercent = listContainer.scrollLeft / (listContainer.scrollWidth - listContainer.clientWidth);
                            const thumbPositionPercentage = scrollPercent * remainingScrollWidthPercentage;
                            scrollbarThumb.style.width = `${scrollbarThumnbWidth}%`;
                            scrollbarThumb.style.left = `${thumbPositionPercentage}%`;
                        }

                        updateScrollbar();
                        listContainer.addEventListener('scroll', updateScrollbar);
                    }
                }

                window.addEventListener('resize', function(){
                    checkOverflowState();
                });

                checkOverflowState();
                initScrollbar();
    		})
    	}

        if (self.modulesSplitContent.length > 0) {
            self.modulesSplitContent.forEach((moduleContainer) => {
                OneTabSystem.init({
                    el: $(moduleContainer)
                });
            })
        }
        
    	if (self.modulesShippingCountdown.length > 0) {
    		self.modulesShippingCountdown.forEach(async (moduleContainer) => {
                const shipToMessageContainer = moduleContainer.querySelector('.shipping-message .ship-to');
                const shippingLocationContainer = moduleContainer.querySelector('.shipping-message .location');
                const countdownTimerContainer = moduleContainer.querySelector('.countdown .timer');

                // Calculate seconds remaining until next 2 PM Pacific Time
                function calcRemainingTime() {
                    const now = new Date();
                    const pacificParts = new Intl.DateTimeFormat('en-US', {
                        timeZone: 'America/Los_Angeles',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        weekday: 'short',
                        hour12: false
                    }).formatToParts(now);
                
                    const currentHour = Number(pacificParts.find(p => p.type === 'hour').value);
                    const currentMinute = Number(pacificParts.find(p => p.type === 'minute').value);
                    const currentSecond = Number(pacificParts.find(p => p.type === 'second').value);
                    const currentDayStr = pacificParts.find(p => p.type === 'weekday').value;
                    const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
                    const currentDay = dayMap[currentDayStr];
                
                    let hoursUntilTarget = 0;
                    let minutesUntilTarget = 0;
                    let secondsUntilTarget = 0;
                
                    const targetHour = 14; // 2 PM
                    if (currentHour >= targetHour) {
                        hoursUntilTarget = targetHour + (23 - currentHour);
                        if (currentDay === 5) { // Friday
                            hoursUntilTarget += 48;
                        } else if (currentDay === 6) { // Saturday
                            hoursUntilTarget += 24;
                        }
                    } else {
                        hoursUntilTarget = targetHour - currentHour;
                        if (currentDay === 0) { // Sunday
                            hoursUntilTarget += 24;
                        } else if (currentDay === 6) { // Saturday
                            hoursUntilTarget += 48;
                        }
                    }
                    const totalSeconds = (hoursUntilTarget * 60 * 60) + ((minutesUntilTarget - currentMinute) * 60) + (secondsUntilTarget - currentSecond);
                    return totalSeconds;
                }

                // Get location data and construct shipping message
                $.getJSON('https://jsonip.com/?callback=?').done(function(data) {
                    $.getJSON( "https://get.geojs.io/v1/ip/geo/"+data.ip+".json", function( data ) {
                        const { region, country_code3: countryCode, city } = data;
                        const isUSA = countryCode === "USA";
                        const hasCity = city !== "";
                        const hasRegion = region !== "";
                        const messages = {
                            standard: "FREE WORLDWIDE SHIPPING",
                            local: "FREE 2-DAY SHIPPING TO",
                            international: "FREE SHIPPING TO"
                        };
                        let shipToMessage = messages.standard;
                        let shippingLocation = "";

                        if (region === "Alaska" || region === "Hawaii") {
                            messages.local = "FREE 3-DAY SHIPPING TO "
                        }

                        if (isUSA) {
                            if (hasCity) {
                                shipToMessage = messages.local;
                                shippingLocation = city;
                            } else if (hasRegion) {
                                shipToMessage = messages.local;
                                shippingLocation = region;
                            }
                        } else {
                            if (hasCity) {
                                shipToMessage = messages.international;
                                shippingLocation = city;
                            } else if (hasRegion) {
                                shipToMessage = messages.international;
                                shippingLocation = region;
                            }
                        };

                        shipToMessageContainer.textContent = shipToMessage;
                        shippingLocationContainer.textContent = shippingLocation;
                    });
                });

                const secondsRemaining = calcRemainingTime();
                const futureTimestamp = Date.now() + (secondsRemaining * 1000);
                const futureDate = new Date(futureTimestamp);

                if (countdownTimerContainer) {
                    setInterval(() => {
                        const now = new Date();
                        const timeDiff = futureDate - now;

                        if (timeDiff <= 0) {
                            countdownTimerContainer.textContent = "00:00:00";
                            return;
                        }

                        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
                        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

                        const formattedTime = 
                            String(hours).padStart(2, '0') + ':' + 
                            String(minutes).padStart(2, '0') + ':' + 
                            String(seconds).padStart(2, '0');

                        countdownTimerContainer.textContent = formattedTime;
                    }, 1000)
                }
    		});
    	}

        if (self.modulesValueProps.length > 0) {
            self.modulesValueProps.forEach((moduleContainer) => {
                const valuePropsList = moduleContainer.querySelector(`.value-props-list`);

                if(self.isMobile()) {
                    $(valuePropsList).slick({
                        dots: true,
                        arrows: false,
                        infinite: true,
                        speed: 300,
                        slidesToShow: 1,
                        adaptiveHeight: false
                    });
                }
            })
        }
    },

    initReadMore: function(){
        const self = this;
        const readMoreBlocks = self.readMoreBlocks;
        
        if (readMoreBlocks.length > 0){
            readMoreBlocks.forEach((block) => {
                const readMoreTrigger = block.querySelector('.read-more');
                
                if (readMoreTrigger) {
                    readMoreTrigger.addEventListener('click', () => {
                        block.classList.toggle('active');
                        readMoreTrigger.textContent = block.classList.contains('active') ? 'Read Less' : 'Read More';
                    });
                }
            });
        }
    },

    initGatedPageModals: function() {
        const self = this;
        const gatedPageModals = self.gatedPageModals;
        
        if (gatedPageModals.length > 0){
            gatedPageModals.forEach((block) => {
                const gatedPageJsonContainer = block;
                const gatedPageConfig = JSON.parse(gatedPageJsonContainer.textContent);
                const { isGatedPage, userCanAccessGatedPage, test1, test2, modal } = gatedPageConfig;
                const modalContent = `
                    <div class="modal-content">
                        <button class="drawer-close"><span class="visually-hidden">Close modal</span></button>
                        <p class="eyebrow">${modal.eyebrowText}</p>
                        <h2 class="heading">${modal.headingText}</h2>
                        <a href="${modal.accountRegisterUrl}" class="register-cta">${modal.ctaText}</a>
                
                        <div class="modal-footer">
                            <p class="login-text">${modal.loginText}</p>
                            <a href="${modal.accountLoginUrl}" class="login-cta">Login Here</a>
                        </div>
                    </div>
                `;
                
                if (isGatedPage && userCanAccessGatedPage) return;
                
                const GatedModalCtl = OneDrawer.init({
                    drawerContent: modalContent,
                    drawerModalId: 'GatedPageModal',
                    drawerType: 'modal',
                    removeOnDestroy: true,
                    dontCloseWhenClickOutside: true,
                    initCallback: function(){
                    },
                    openCallback: function(){                                
                    },
                    closeCallback: function(){
                    },
                });
                
                GatedModalCtl.openDrawer();

            });
        }
    },
    
    initEducationBanner: function() {
        var self = this;
        const $educationBanners = $('.education-banner');
        
        if ($educationBanners.length > 0) {
            $educationBanners.each(function() {
                const $banner = $(this);
                const $videos = $banner.find('.video-wrapper');
                
                if ($videos.length > 0) {
                    OneVideo.init({
                        el: $videos,
                        isResponsive: false,
                        bgVideo: true,
                        autoplay: true
                    });
                }
            });
        }
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    },

    devTools: function(){
        var self = this;
        var $indicator = $('#responsive-indicator');
        var $previewBar = $('#preview-bar-iframe');

         // This should only run when a theme is being previewed.
        if(Shopify.PreviewBarInjector !== undefined){
            if($indicator.length > 0 && $previewBar.length > 0 && Shopify.PreviewBarInjector.length == 1){
                $indicator.text("Preview: " + Shopify.theme.name).removeClass("hide");
                var events = {
                    'click #responsive-indicator': function(e){
                        $indicator.toggleClass('active');
                        $previewBar.toggleClass('active');
                    }
                };

                _.extend(self.events, events);
                self.delegateEvents();
            }else{
                $indicator.addClass("hide");
            }
        }
    },
    /**
     * DD-3426 Feedback fix to reinit the cart without opening the drawer component
     */
    initCartOnPageLoad: function(){
        fetch('/cart.json').then( res => res.json()).then( cart => {
            if(cart.items.length > 0 ){
                let updates = {
                    [cart.items[0].key]: cart.items[0].quantity,
                };
                fetch('/cart/update.js',{
                    method: 'POST',
                    headers:{ 
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                }).then(response => {
                    response.drawerClose = true
                    publish(PUB_SUB_EVENTS.cartUpdate, response)
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        })
    }
});